<header
  class="page-header"
  [ngClass]="{
    'page-header__no-image page-header--no-image-height': !pageUnit.coverImage,
    'page-header__no-image--viewer': !userEditable,
    'page-header__no-image--title-larger-than-one' : titleHeightChange && !pageUnit.coverImage,
    'page-header--edit-mode': userEditable}"
  bulbHeaderEffects
  [formGroup]="formGroup"
>
  <bulb-header-image-controls
    *ngIf="userEditable"
    [hasCoverImage]="!!pageUnit.coverImage"
    [commandsFromAjs]="commandsFromAjs"
    [formControlName]="'headerEffectType'"
    class="page-header__menubar"
  ></bulb-header-image-controls>

  <bulb-header-image
    *ngIf="pageUnit.coverImage"
    [imageAsset]="pageUnit.coverImage"
    [imageEffect]="pageUnit.headerEffectType"
    class="page-header__bg"
  ></bulb-header-image>

  <div
    class="page-header__heading"
    [ngClass]="{
      'page-header__heading--hidden': pageUnit.titleHidden,
      'page-header__heading--no-image-viewer-margin': !pageUnit.coverImage && !userEditable}"
    >
    <h1 *ngIf="userEditable"
      class="page-title"
      contenteditable
      [attr.aria-label]="'pageView.pageTitle.placeholder' | transloco"
      [bulbAutofocus]="!pageUnit.name"
      [disabled]="!userEditable"
      [formControlName]="'name'"
      [maxlength]="70"
      bulbContenteditableSupport
      bulbResizeObserver
      (resizeEventEmitter)="titleSizeChanges($event)"
    >{{ pageUnit.name }}</h1>
    <h1 *ngIf="!userEditable"
      class="page-title"
    >{{ pageUnit.name }}</h1>

    <div class="byline-with-tags">
      <bulb-user-byline
        [displayProps]="pageUnit.ownerDisplayProps">
      </bulb-user-byline>

      <div class="selected-tags-row" *ngIf="pageUnit.tags.length">
        <span *ngFor="let tag of pageUnit.tags">
          <aero-tags
            [name]="tag.name"
            [showCross]="!previewStateActive && userEditable"
            [color]="tag.colorCode"
            (crossClicked)="showConfirmDialog(tag)">
          </aero-tags>
        </span>
      </div>
      <span *ngIf="pageUnit.tags.length < 3 && (!previewStateActive && userEditable)"
        type="button" aeroTooltip="{{ 'tags.dialog.addTags' | transloco }}"
        class="add-tag-btn"
        (click)="openTagsDialog()"
        aria-label="Add tags">
        <i class="fa fa-plus"></i>
      </span>
    </div>

  </div>

</header>
